import { ImageOff } from "lucide-react";

// A local, network-free fallback for missing/broken product images. No
// external URL involved, so there's nothing to be slow or fail to load.
export function ImageFallback({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center bg-white text-gray-300 ${className}`}>
      <ImageOff className="w-1/3 h-1/3" strokeWidth={1.5} />
    </div>
  );
}
